import React from "react";
import { ListGroup, ListGroupItem } from "reactstrap";
import { Link } from "react-router-dom";

export const mailFolderListItems = (
  <div className="rmc-drawer-sidebar-dark-theme inside-drawer">
    <ListGroup>
      {/* <ListGroupItem>
        <Link to="">Login</Link>
      </ListGroupItem>

      <ListGroupItem>
        <Link to="">Signup</Link>
      </ListGroupItem> */}

      <ListGroupItem>
        <Link to="/signup">SIGN UP</Link>
      </ListGroupItem>
      <ListGroupItem>
        <Link to="/login">LOG IN</Link>
      </ListGroupItem>
    </ListGroup>
  </div>
);

export default mailFolderListItems;



// WEBPACK FOOTER //
// ./components/Drawer/tileData.js